var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "d-flex justify-content-around h-100 w-100 mobile-nav-item-container",
    },
    [
      _c("router-link", {
        attrs: { to: { name: "Welcome", params: { uuid: _vm.id } } },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ href, route, navigate, isActive, isExactActive }) {
              return [
                _c(
                  "div",
                  {
                    staticClass: "mobile-nav-item",
                    class: [
                      isActive && "active",
                      isExactActive && "exact-active",
                    ],
                    on: { click: navigate },
                  },
                  [
                    _c("div", { staticClass: "mobile-nav-icon" }, [
                      _c("i", { staticClass: "far fa-2x fa-download" }),
                    ]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm._f("trans")("Download")))]),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c("router-link", {
        attrs: { to: { name: "FileList", params: { uuid: _vm.id } } },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ href, route, navigate, isActive, isExactActive }) {
              return [
                _c(
                  "div",
                  {
                    staticClass: "mobile-nav-item",
                    class: [
                      isActive && "active",
                      isExactActive && "exact-active",
                    ],
                    on: { click: navigate },
                  },
                  [
                    _c("div", { staticClass: "mobile-nav-icon" }, [
                      _c("i", { staticClass: "far fa-list fa-2x" }),
                    ]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm._f("trans")("Files")))]),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }